const labels = ["Account", "Brand", "Instagram", "Posts"];

export function Steps({ at }: { at: number }) {
  return (
    <ol className="steps" aria-label="Getting started">
      {labels.map((l, i) => (
        <li
          key={l}
          className={`s ${i < at ? "done" : i === at ? "on" : ""}`}
          aria-current={i === at ? "step" : undefined}
        >
          <span className="n">{i < at ? "✓" : i + 1}</span> {l}
        </li>
      ))}
    </ol>
  );
}
